import React from 'react';

import classes from './ImageCard.module.scss';
import { getFileName } from 'helpers/FileCaching';

//Images
const imageCardImages = require.context('../../../../assets/images/Article/ImageCard', true, /.*\.(gif|png|jpe?g|svg)$/i);

const ImageCard = ({content, author, windowSize}) => {

	return(
		<div className={`container ${classes.ImageCard}`}>
			<div className={`row`}>
				<div className={`${classes.ImageCard__content}`}>
					<div className={`${classes.ImageCard__image}`}
						style={
							{
								backgroundImage: 'url(' + getFileName(imageCardImages,content.image[windowSize]) + ')'
							}
						}>
					</div>
					<h5 className={classes.ImageCard__caption}>{content.caption}</h5>
				</div>
			</div>
		</div>
	)

}

export default ImageCard;